import { toast } from 'react-toastify';
import Swal from 'sweetalert2'

export const useActions = ({
    marvarApi, user, toggle,
    FetchData, Helpers,
    Forms,
    globalStates

}) => {

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        const { FormCollateral: { onResetForm } } = Forms
        onResetForm()
        closeModal()
    }

    const onSubmitFormCollateral = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormCollateral: { formState } } = Forms

        const { modalOpeningMode } = globalStates

        const { fetchAllCollateral: { executeFetchCollateral } } = FetchData

        //Validaciones generales
        if (formState.type_collateral === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de garantia',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            title: formState.title,
            type_collateral: formState.type_collateral,
            estate: formState.estate,
            folio: formState.folio,
            department: formState.department,
            book: formState.book,
            description: formState.description,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idcollateral > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/credits/mgmt-managements/collateral/${formState.idcollateral}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchCollateral()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickCloseModal()
            }

        }

    }


    const handleClickFetchInfoCollateral = async (idcollateral, modeOpening) => {

        const { FormCollateral: { onResetForm, setFormState } } = Forms

        const { fetchInfoCollateral: { setParamsToSearch, executeFetchInfoCollateral } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idcollateral: idcollateral })
        executeFetchInfoCollateral()

        setFormState(prevState => ({
            ...prevState,
            idcollateral: idcollateral
        }))


        handleClickShowModal('', 'Formulario de Garantias', 'collateral-section', {}, modeOpening)

    }

    const handleClickOpenCollateralImages = (idcollateral, modeOpening) => {
        const { FormCollateral: { setFormState } } = Forms
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData

        const { setFormOpeningMode, setShowSection, setImagesCurrentIndex } = globalStates

        // set modo (EDITABLE / READONLY)
        setFormOpeningMode(modeOpening)

        // set id y limpia arrays para que no se mezclen
        setFormState(prev => ({
            ...prev,
            idcollateral,
            images: [],
            acceptedFiles: [],
            fileRejections: []
        }))

        setImagesCurrentIndex(0)
        executeFetchCollateralImages()
        setShowSection('IMAGE') // o 'IMAGENES' según tu convención
    }

    const handleClickCloseCollateralImages = () => {
        const { setShowSection, setImagesCurrentIndex } = globalStates
        const { FormCollateral: { onResetForm } } = Forms

        onResetForm()
        setImagesCurrentIndex(0)
        setShowSection('HOME')
    }

    const handleNextCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const { setImagesCurrentIndex } = globalStates

        const images = formState.images || []
        if (images.length <= 0) return

        setImagesCurrentIndex(prev => (prev + 1 < images.length ? prev + 1 : 0))
    }

    const handlePreviousCollateralImage = () => {
        const { FormCollateral: { formState } } = Forms
        const { setImagesCurrentIndex } = globalStates

        const images = formState.images || []
        if (images.length <= 0) return

        setImagesCurrentIndex(prev => (prev - 1 >= 0 ? prev - 1 : images.length - 1))
    }

    const handleClickCleanUpCollateralImagesFiles = () => {
        const { FormCollateral: { setFormState } } = Forms

        setFormState(prev => ({
            ...prev,
            acceptedFiles: [],
            fileRejections: [],
        }))
    }


    const handleClickDeleteCollateralImage = (idimagen) => {
        const { FormCollateral: { formState } } = Forms
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData

        const idcollateral = formState.idcollateral

        Swal.fire({
            title: '¿Desea eliminar esta imagen?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (!result.isConfirmed) return

            await marvarApi
                .delete(`/credits/collateral/${idcollateral}/images/${idimagen}`)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') executeFetchCollateralImages()
                })
                .catch(err => console.log('API ERROR:', err))
        })
    }

    const onSubmitCollateralImages = async (e) => {
        e.preventDefault()

        const { getCurrentDate } = Helpers
        const { FormCollateral: { formState, setFormState } } = Forms
        const { fetchCollateralImages: { executeFetchCollateralImages } } = FetchData

        if (formState.idcollateral <= 0) {
            alertMessage({ title: 'FAIL', message: 'No hay garantía seleccionada', rows: [] })
            return
        }

        if (!formState.acceptedFiles || formState.acceptedFiles.length <= 0) {
            alertMessage({ title: 'FAIL', message: 'No se ha cargado ninguna imagen', rows: [] })
            return
        }

        const _data = new FormData()
        _data.append('usuario_creo', user.username)
        _data.append('fecha_creo', getCurrentDate())

        // OJO: si tu backend espera otro key, cámbialo aquí
        formState.acceptedFiles.forEach((file) => {
            _data.append('images', file)
        })

        await marvarApi
            .post(`/credits/collateral/${formState.idcollateral}/images`, _data)
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState(prev => ({
                        ...prev,
                        acceptedFiles: [],
                        fileRejections: []
                    }))
                    executeFetchCollateralImages()
                }
            })
            .catch(err => console.log('API ERROR:', err))
    }


    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }


    return Object.freeze({
        handleClickCloseModal,
        onSubmitFormCollateral,
        handleClickFetchInfoCollateral,
        handleClickOpenCollateralImages,
        handleClickCloseCollateralImages,
        onSubmitCollateralImages,
        handleClickDeleteCollateralImage,
        handleClickDownloadImage,
        handleNextCollateralImage,
        handlePreviousCollateralImage,
        handleClickCleanUpCollateralImagesFiles,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}